export default "__VITE_ASSET__8ebr1eb9__"